import React from 'react';
import { withTranslation } from 'react-i18next';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import {
    Box,
    Card,
    InternalGrid,
    Link as UILink,
    Text,
    Title,
} from '@paygreen/paygreen-ui';
import { useUser } from '../../../context';
import Message from '../../layout/Message';
import IconByName from '../../../utils/IconByName';
import { IsDesktop } from '../../../utils/tools';
import { charityAccountStatus } from '../../../utils/constants';

const CharityMessage = ({ t }) => {
    const { user } = useUser();
    const { pathname } = useLocation();
    const isCharityPage = pathname === '/user/charity';

    let mode = null;
    let colorStatus = null;
    const colorPallet = 'status';

    switch (true) {
        case !user?.isValidated &&
            (user?.isReadyToOnboard || user?.isOnboardingCompleted):
            mode = charityAccountStatus.onGoing;
            colorStatus = 'default';
            break;
        case user?.isValidated:
            mode = charityAccountStatus.validated;
            colorStatus = 'success';
            break;
        default:
            mode = charityAccountStatus.missingData;
            colorStatus = 'warning';
            break;
    }

    const colorProps = { colorStatus, colorPallet };

    const LinksInMessage = () => (
        <RouterLink to="/user/charity">
            <UILink {...colorProps}>
                {t(`charityMessages.missingData.link`)}
            </UILink>
        </RouterLink>
    );

    const modeProps = {
        missingData: {
            type: 'warning',
            messageContent: (
                <>
                    {isCharityPage ? (
                        <Text textSize="sm" {...colorProps}>
                            {t(`charityMessages.${mode}.message`)}
                        </Text>
                    ) : (
                        <Text textSize="sm" {...colorProps}>
                            {t(`charityMessages.missingData.messageWithLink`)}
                            <LinksInMessage />
                        </Text>
                    )}
                </>
            ),
            icon: 'PenIcon',
        },
        onGoing: {
            type: 'default',
            messageContent: (
                <Text textSize="sm" {...colorProps}>
                    {t(`charityMessages.${mode}.message`)}
                </Text>
            ),
            icon: 'HourglassIcon',
        },
        validated: {
            type: 'success',
            messageContent: (
                <>
                    <Text textSize="sm" {...colorProps}>
                        {t(`charityMessages.${mode}.message`)}
                    </Text>
                </>
            ),
            icon: 'CheckIcon',
        },
    };

    const paddingProp = !isCharityPage ? 'xs' : 'sm';

    return (
        <Box marginBottom={isCharityPage ? 'none' : 'md'}>
            <Card
                blockWidth={!isCharityPage ? 'xl' : 'md'}
                shadowSize="none"
                paddingLateral={paddingProp}
                paddingTop={paddingProp}
                paddingBottom={paddingProp}
                radiusSize="sm"
                {...colorProps}
            >
                {isCharityPage ? (
                    <>
                        <InternalGrid
                            displayType="grid"
                            gridGap="sm"
                            gridTemplateColumns="auto 1fr"
                            alignItems="flex-start"
                            justifyItems="start"
                        >
                            <IconByName
                                name={modeProps[mode].icon}
                                {...colorProps}
                            />

                            <Title
                                htmlTag="h3"
                                {...colorProps}
                                marginBottom="xs"
                            >
                                {t(`charityMessages.${mode}.title`)}
                            </Title>
                        </InternalGrid>

                        {modeProps[mode].messageContent}
                    </>
                ) : (
                    <Message
                        icon={!isCharityPage && modeProps[mode].icon}
                        iconSize="md"
                        textSize="sm"
                        type={modeProps[mode].type}
                        blockWidth="sm"
                        hasStaticWidth={!isCharityPage || !IsDesktop()}
                        paddingLateral="none"
                    >
                        {modeProps[mode].messageContent}
                    </Message>
                )}
            </Card>
        </Box>
    );
};

export default withTranslation('common')(CharityMessage);
